import type { TableComponent } from './table';
import type { ChartComponent } from './chart';
import type { CardComponent } from './card';

/**
 * Discriminated union of all UI components
 */
export type UIComponent = TableComponent | ChartComponent | CardComponent;

/**
 * Type guard for TableComponent
 */
export function isTableComponent(component: UIComponent): component is TableComponent {
    return component.type === 'table';
}

/**
 * Type guard for ChartComponent
 */
export function isChartComponent(component: UIComponent): component is ChartComponent {
    return component.type === 'chart';
}

/**
 * Type guard for CardComponent
 */
export function isCardComponent(component: UIComponent): component is CardComponent {
    return component.type === 'card';
}

// Re-export all schemas
export type { TableComponent, TableColumn } from './table';
export type { ChartComponent, ChartDataset } from './chart';
export type { CardComponent, CardAction } from './card';
